let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ge5BM")).then(() => parcelRequire('2qR2u'));